<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="应用类型(1私有应用,0第三方应用)" prop="appType">
          <el-input v-model="dataForm.appType" placeholder="应用类型(1私有应用,0第三方应用)"></el-input>
      </el-form-item>
          <el-form-item label="应用id" prop="appId">
          <el-input v-model="dataForm.appId" placeholder="应用id"></el-input>
      </el-form-item>
          <el-form-item label="应用名称" prop="appName">
          <el-input v-model="dataForm.appName" placeholder="应用名称"></el-input>
      </el-form-item>
          <el-form-item label="应用介绍" prop="appIntroduce">
          <el-input v-model="dataForm.appIntroduce" placeholder="应用介绍"></el-input>
      </el-form-item>
          <el-form-item label="应用token获取" prop="appTokenFetch">
          <el-input v-model="dataForm.appTokenFetch" placeholder="应用token获取"></el-input>
      </el-form-item>
          <el-form-item label="accessToken" prop="accessToken">
          <el-input v-model="dataForm.accessToken" placeholder="accessToken"></el-input>
      </el-form-item>
          <el-form-item label="refreshToken" prop="refreshToken">
          <el-input v-model="dataForm.refreshToken" placeholder="refreshToken"></el-input>
      </el-form-item>
          <el-form-item label="权限情况" prop="permissionSituation">
          <el-input v-model="dataForm.permissionSituation" placeholder="权限情况"></el-input>
      </el-form-item>
          <el-form-item label="状态(1启用,0禁用)" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态(1启用,0禁用)"></el-input>
      </el-form-item>
              <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
          <el-form-item label="广告主id" prop="accountId">
          <el-input v-model="dataForm.accountId" placeholder="广告主id"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        appType: '',
        appId: '',
        appName: '',
        appIntroduce: '',
        appTokenFetch: '',
        accessToken: '',
        refreshToken: '',
        permissionSituation: '',
        status: '',
        createDate: '',
        creator: '',
        remark: '',
        accountId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        appType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        appId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        appName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        appIntroduce: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        appTokenFetch: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accessToken: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        refreshToken: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        permissionSituation: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accountId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/tencentadsapp/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/tencentadsapp/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
